<template>
    <v-container fluid class="my-0 pa-0">
        <q-agency-building-submenu />
        <v-row justify="space-between" align="stretch" class="mx-5 q-sticky-buffer">
            <v-col cols="6">
                <h2>Tenant Staff Accounts 
                </h2>
                <v-btn color="secondary" :disabled="tenant_id == null" @click="showAddStaff">Add Staff Login</v-btn>
            </v-col>
            <v-col cols="6">
                <v-select label="Tenant" :items="all_tenants" v-model="currentTenant" item-value="ID" item-text="Tenant" ></v-select>
            </v-col>
            <v-col cols="12" v-if="tenant_id">
                <q-staff-data-table :tenant-id="tenant_id" ref="staff_data" v-on:edit="editStaff"></q-staff-data-table>
            </v-col>
            <v-col cols="12" v-else>
                Select a tenant first.
            </v-col>
        </v-row>
        <v-dialog v-model="show_staff" width="500">
            <v-card>
                <v-card-title>Add Staff Login</v-card-title>
                <v-card-text >
                    <q-form-add-staff :primary-tenant="tenant_id" :staff="current_staff" v-on:saved="insertSavedUser"></q-form-add-staff>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import QAgencyBuildingSubmenu from '@/components/navigation/Submenus/QAgencyBuildingSubmenu.vue'
import QFormAddStaff from '@/components/agent_admin/QFormAddStaff.vue'
import QStaffDataTable from '@/components/datatables/QStaffDataTable.vue'
export default {
    name: "ManageTenantStaff",
    data() {
        return {
            tenant_id: null,
            show_staff: false,
            current_staff: {}
        };
    },
    mounted: function() {

    },
    computed: {
        currentTenant : {
            get: function () {
                this.tenant_id = this.current_tenant.ID === null ? null : this.current_tenant.ID
                return this.tenant_id
            },
            set: function (tenant_id) {
                this.tenant_id = tenant_id;
            }
        }
    },
    methods: {
        showAddStaff: function() {
            this.current_staff = { user_id: null, Tenants: [] }
            this.show_staff = true
        },
        editStaff: function(user) {
            this.current_staff = user
            this.current_staff.new_email = user.email
            this.show_staff = true
        },
        insertSavedUser: function(user) {
            this.show_staff = false
            var exists = false
            var g = this
            this.$refs.staff_data.the_data.forEach(function(u, ix) {
                if (u.user_id == user.user_id) {
                    g.$refs.staff_data.the_data[ix] = user;
                    exists = true
                    console.log(g.$refs.staff_data.the_data[ix])
                }
            })
            if (!exists) {
                this.$refs.staff_data.the_data.push(user)
            }
            console.log(user)
        }
    },
    watch: {

    },
    components: {
        QFormAddStaff,
        QStaffDataTable,
        QAgencyBuildingSubmenu,
    }
};
</script>